import React from 'react';
import cn from "classnames";
import useTrans from "components/hooks/useTrans";

type Props = {
    className?: string;
};

export default function TableOfContents(props: Props) {
    const { t } = useTrans();
    const className = cn(
        props.className ?? ""
    );

    return (
        <div className={`hidden lg:inline-block ${className}`}>
            <span className={"text-purple-tint-dark font-normal text-sm tracking-widest uppercase"}>
                {t('tableOfContents')}
            </span>
            <div className={"table-of-contents mt-4 pl-2 border-l-2 border-purple-tint-light"}/>
        </div>
    );
}